<template>
    <div class='card'>
        <DynamicImageContainer class="product-image" :image='product.main_picture' />
        <div>{{product.product}}</div>
        <div>£{{product.price}}</div>
    </div>
</template>

<script>
import DynamicImageContainer from "@/ecom/components/images/DynamicImageContainer.vue";
export default {
    components: {DynamicImageContainer}, 
    props: ['product'],
}
</script>

<style lang="scss" scoped>
.card{
    display: flex;
    flex-direction: column;
    gap: 5px;
    width: 250px;
}
.product-image{
    width: 60px;
    object-fit: cover;
    cursor: pointer;
    margin-left: 60px;
}
</style>